<template>
  <div >
    
    <section class="section">
      <p class="title is-2 has-text-centered has-text-primary">
        Investment Idea Generator
      </p>
      <p class="subtitle is-6 has-text-centered has-text-grey">
        Enter any phrase or idea to discover relevant funds and companies, powered by AI. 
        <br>
        All companies are real and traded today. 
        <br>
      </p>
      <br>
      <div class="columns is-centered">
        <div class="column is-two-thirds" >
          <form @submit.prevent="submitSearch">
            <div class="field has-addons">
                <p class="control is-expanded">
                  <input
                    v-model="searchText"
                    @input="unsubmitSearch"
                    class="input is-focused is-primary" type="text" placeholder="What's your investment idea?"
                  >
                </p>
                <p class="control">
                  <button class="button is-primary" @click="submitSearchFast">
                    Fast 
                  </button>
                  <button class="button is-primary" @click="submitSearch">
                    More Accurate 
                  </button>
                </p>
            </div>
            <div class="field is-horizontal">
              <div class="field-label is-medium">
                <label class="label">Need Inspiration?</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="control">
                    <p class="tags is-medium">
                      <a v-for="exampleSearch in exampleSearches" class="tag is-medium" @click="newSearch(exampleSearch)">
                        {{ exampleSearch }}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            
          </form>
        </div>
      </div>
    </section>
    
    
    <!-- results -->
    <section class="section" v-if="searchSubmitted">
      <div class="columns is-centered">
        <div class="column is-two-thirds">
          <GenerationResult 
            :searchText="searchText"
            :fastSearch="fastSearch"
          />
        </div>
      </div>
    </section>
    
    
    
    
  </div>
</template>


<script>
import GenerationResult from '@frontend/ui/components/portfolio-generator/GenerationResult.vue';
import { nextTick } from 'vue';
export default {
  name: 'generate-portfolio-view',
  components: { GenerationResult },
  props: [/* Inputs */],
  data() {
    return { 
      searchText: '',
      searchSubmitted: false,
      fastSearch: true,
      exampleSearches: [
        'Manufacturers of ski equipment',
        'Lithium and other rare metals used for making electric batteries',
        'Generative AI']
     };
  },
  beforeCreate() {},
  created() {},
  mounted() {
    if (window.location.hash) {
      this.searchText = window.decodeURI(window.location.hash.slice(1));
      this.submitSearch();
    }
  },
  updated() {},
  computed: { /*
    Creates a new property
    Updates when any dependant property changes */
  },
  watch: { /*
    Watches an existing property
    Only runs when the watched property changes */
  },
  methods: {
    newSearch(query) {
      this.searchText = query;
      this.searchSubmitted = false;
      nextTick(() => {
        this.submitSearch();
      })
    },
    unsubmitSearch() {
      this.searchSubmitted = false;
      window.location.hash = '';
    },
    submitSearch() {
      this.fastSearch = false
      this.searchSubmitted = true;
      window.location.hash = this.searchText;
    },
    submitSearchFast() {
      this.fastSearch = true
      this.searchSubmitted = true;
    }
  },
};
</script>


<style scoped>

</style>
